module.exports = __webpack_public_path__ + "static/media/record-1.69f1cfc1.png";